import { createRoot } from 'react-dom/client'
import { makeMainRoutes } from './routes'

const routes = makeMainRoutes()

const container = document.getElementById("root");
const root = createRoot(container);
root.render(routes);